module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel",
    class: {
      opened: _vm.opened, selected: _vm.isSelected, 'not-selected': !_vm.isSelected
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onSelect($event)
      }
    }
  }, [_c('emblem', {
    staticClass: "click-target",
    attrs: {
      "character": _vm.character
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-386cb676","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CharacterPanel.vue
// module id = 547
// module chunks = 1